import { Modal } from '@/components/ui/Modal'

type StreetViewModalProps = {
	onClose: () => void
	apiKey: string
	lat: number
	lon: number
}

export default function StreetViewModal({
	onClose,
	apiKey,
	lat,
	lon,
}: StreetViewModalProps) {
	return (
		<Modal streetViewModal onClose={onClose} fullModal>
			<iframe
				sandbox="allow-scripts"
				title="streetview"
				loading="lazy"
				height="100%"
				width="100%"
				src={`https://www.google.com/maps/embed/v1/streetview?key=${apiKey}&location=${lat},${lon}`}
			></iframe>
		</Modal>
	)
}
